export const breakpointUtils = {
  greaterThan: greaterThan,
};

function greaterThan(size: "sm"): boolean {
  return false;
}
